export const GET_ALL_PENDINGS = 'GET_ALL_PENDINGS'
export const DISABLE_PENDENCY = 'DISABLE_PENDENCY'
export const RESOLVE_PENDENCY = 'RESOLVE_PENDENCY'
export const LOCAL_UPDATE_LIST = 'LOCAL_UPDATE_LIST'
export const GET_ALL_PENDING_TYPES = 'GET_ALL_PENDING_TYPES'
export const FETCH_PENDING_INDICATORS = 'FETCH_PENDING_INDICATORS'
export const GET_PENDENCIES_FOR_ALERT = 'GET_PENDENCIES_FOR_ALERT'
export const SET_PENDING_MODAL_VISIBLE = 'SET_PENDING_MODAL_VISIBLE'
export const INCREMENT_COUNT_OF_UPDATE = 'INCREMENT_COUNT_OF_UPDATE'
export const GET_PENDING_BY_ID = 'GET_PENDING_BY_ID'
export const PENDING_IS_APPLICATION_LOADING = 'PENDING_IS_APPLICATION_LOADING'

export const REMOVE_PENDINGS_FOR_LIST = 'REMOVE_PENDINGS_FOR_LIST'
